import { defineComponent as _defineComponent } from 'vue'
interface TInputGroupProps {}

export default /*#__PURE__*/_defineComponent({
  __name: 't-input-group',
  setup(__props: any) {

const props = __props as {};



return { __sfc: true,props }
}

})